import { createRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { rootRoute } from './__root';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';
import { PermissionGate } from '@/components/admin/permission-gate';
import { AdminSubNav } from '@/components/admin/admin-sub-nav';
import { HealthTileGrid } from '@/components/admin/health-tile-grid';
import { SilentKillerBanner } from '@/components/admin/silent-killer-banner';

export const adminObservabilityOverviewRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/observability',
  component: AdminObservabilityOverviewPage,
});

function AdminObservabilityOverviewPage() {
  return (
    <PermissionGate permission="platform:observe">
      <Overview />
    </PermissionGate>
  );
}

function Overview() {
  const healthQuery = useQuery({
    queryKey: queryKeys.admin.health(),
    refetchInterval: 5_000,
    queryFn: async () => {
      const { data, error } = await apiClient.GET('/admin/observability/health');
      if (error) throw error;
      return data;
    },
  });

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h1 className="text-2xl font-semibold">Observability</h1>
        <p className="text-xs text-muted-foreground">
          Platform-wide health, capacity, and recent events for tenant
          owners. Polling: health every 5s.
        </p>
      </div>
      <AdminSubNav active="overview" />
      {healthQuery.isLoading && (
        <p className="text-sm text-muted-foreground">Loading health…</p>
      )}
      {healthQuery.isError && (
        <p className="text-sm text-red-600" data-testid="admin-overview-error">
          Failed to load system health.
        </p>
      )}
      {healthQuery.data && (
        <>
          <SilentKillerBanner health={healthQuery.data} />
          <HealthTileGrid components={healthQuery.data.components} />
        </>
      )}
    </div>
  );
}
